export default __webpack_public_path__ + "static/media/quote.e6e8004b.svg";